import db from '@/rxdb/database';
import { map } from 'rxjs';

function mapInvoiceReviews(item) {
    if (item) {
        const plainItem = item.toMutableJSON();
        return {
            ...plainItem,
            emissionDate: plainItem.emissionDate ? new Date(plainItem.emissionDate) : null,
            emissionDueDate: plainItem.emissionDueDate ? new Date(plainItem.emissionDueDate) : null,
        };
    } else {
        return null;
    }
}
export function getInvoiceReviews(projectId, invoiceId) {
    return db
        .getProjectCollections(projectId)
        .invoiceReviews.find({ selector: { invoiceId } })
        .$.pipe(map((items) => items.map(mapInvoiceReviews)));
}
export function getInvoicesReviews(projectId) {
    return db
        .getProjectCollections(projectId)
        .invoiceReviews.find({})
        .$.pipe(map((items) => items.map(mapInvoiceReviews)));
}

export function removeInvoiceReviews(projectId, id) {
    return db
        .getProjectCollections(projectId)
        .invoiceReviews.findOne({ selector: { id: id } })
        .remove();
}

export async function createInvoiceReviews(projectId, invoiceId, item) {
    const result = await db.getProjectCollections(projectId).invoiceReviews.insert({
        projectId,
        invoiceId,
        ...item,
        emissionDate: item.emissionDate ? item.emissionDate.toISOString() : null,
        emissionDueDate: item.emissionDueDate ? item.emissionDueDate.toISOString() : null,
    });
    return result.toJSON();
}

export async function updateInvoiceReview(projectId, invoiceReview) {
    const dbInvoice = await db
        .getProjectCollections(projectId)
        .invoiceReviews.findOne({ selector: { id: invoiceReview.id } })
        .exec();
    const patch = { ...JSON.parse(JSON.stringify(invoiceReview)) };
    if (invoiceReview.emissionDate === null || !!invoiceReview.emissionDate) {
        patch.emissionDate = invoiceReview.emissionDate ? invoiceReview.emissionDate.toISOString() : null;
    }
    if (invoiceReview.emissionDueDate === null || !!invoiceReview.emissionDueDate) {
        patch.emissionDueDate = invoiceReview.emissionDueDate ? invoiceReview.emissionDueDate.toISOString() : null;
    }
    return dbInvoice.atomicPatch(patch);
}
